import img from './img';
import audio from './audio';
import gameData from './gameData.config.js';

var config = {
  author: 'TR',
  engine: 'ImageSelect',
  hideControlPanel: true,
  gameConfig: gameData,
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
